import { useTranslation } from '@/i18n/client';
import { observer } from 'mobx-react';
import styles from './index.module.scss';
// 组件
import UKDialog from '@/components/UKDialog';
import CDNImage from '@/components/cdnImage/cdnImage';
import { DialogTitle } from '@mui/material';
// 接口
import { DeliveryinfoVo } from '@/apis/order/order.interface';

interface pickupDetailsModalProps {
  isOpen: boolean;
  closeHandler: () => void;
  modalInfo: DeliveryinfoVo | undefined;
}

const pickupDetailsModal: React.FC<pickupDetailsModalProps> = observer(
  ({ isOpen, closeHandler, modalInfo }) => {
    const { t } = useTranslation();

    const { selfPickupName, selfPickupAddress, selfPickupBusinessHours, storePicUrl } =
      modalInfo || {};

    return (
      <UKDialog
        open={isOpen}
        onClose={closeHandler} // 关闭弹窗
        showCloseBtn={true}
        sx={{
          '& .MuiDialog-paper': {
            width: '600px', // 设置自定义宽度
          },
        }}
      >
        <DialogTitle
          sx={{
            paddingTop: '20px',
            paddingBottom: '12px',
          }}
        >
          {t('order.orderDetail.pickupDetailsModal.modalTitle')}
        </DialogTitle>
        <div className={styles.contentWrap}>
          {/* 自提点照片 */}
          {storePicUrl ? (
            <div className={styles.storeImgWrap}>
              <CDNImage
                src={storePicUrl}
                width={552}
                height={372}
                alt='product_img'
                style={{ objectFit: 'contain', height: '372px', borderRadius: '4px' }}
              />
            </div>
          ) : null}
          {/* 自提点地址 */}
          <div className={styles.storeAddress}>
            <div className={styles.logisticsTitle}>{selfPickupName}</div>
            <div className={styles.logisticsDesc}>{selfPickupAddress}</div>
          </div>
          {/* 自提点营业时间 */}
          {!!selfPickupBusinessHours?.length && (
            <div className={styles.storeOpeningTime}>
              <div className={styles.openingTimeTitle}>
                {t('afterSales.afterSalesAccordion.openingTime')}
              </div>
              {selfPickupBusinessHours?.map((item: string, index: number) => {
                return (
                  <div className={styles.openingTimeItem} key={`pickupOpeningTimeItem_${index}`}>
                    {item}
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </UKDialog>
    );
  },
);

export default pickupDetailsModal;
